import { render, staticRenderFns } from "./ResponseDaysCustomField.vue?vue&type=template&id=510a6eb3"
import script from "./ResponseDaysCustomField.vue?vue&type=script&lang=js"
export * from "./ResponseDaysCustomField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports